import { Pipe, PipeTransform } from '@angular/core';
import { TabloStaticTextConfigOptions } from '@ui/tablo-generator/types';

@Pipe({
    name: 'staticTextHorizontalAligment',
    standalone: false
})
export class StaticTextHorizontalAligmentPipe implements PipeTransform {
  transform(
    value: TabloStaticTextConfigOptions,
    zIndex: number,
  ): Record<string, any> {
    const staticStyle = {
      'padding.px': value.padding,
      'border-radius.px': value.borderRadius,
      'background-color': value.background,
    };
    switch (value.verticalAlign) {
      case 'top':
        return {
          display: 'flex',
          'align-items': 'flex-start',
          width: '100%',
          'z-index': zIndex.toString(),
          ...staticStyle,
        };
      case 'center':
        return {
          display: 'flex',
          'align-items': 'center',
          width: '100%',
          'z-index': zIndex.toString(),
          ...staticStyle,
        };
      case 'bottom':
        return {
          display: 'flex',
          'align-items': 'flex-end',
          width: '100%',
          'z-index': zIndex.toString(),
          ...staticStyle,
        };
    }
  }
}
